import type { IconContainerProps } from './typings'

import { IconContainer } from './elements/IconContainer'

export function DeliveryTruck(props: IconContainerProps) {
  return (
    <IconContainer {...props}>
      <svg viewBox="0 0 44 32">
        <path
          d="M26.25 4.5H34.8982C35.6204 4.49996 36.3183 4.76039 36.8639 5.2335C37.4095 5.70661 37.7661 6.36063 37.8683 7.0755L39 15H40.5C41.2956 15 42.0587 15.3161 42.6213 15.8787C43.1839 16.4413 43.5 17.2044 43.5 18V25.5C43.5 25.8978 43.342 26.2794 43.0607 26.5607C42.7794 26.842 42.3978 27 42 27H26.25V4.5Z"
          fill="#4383CC"
        />
        <path
          d="M30 4.5V13.5C30 13.8978 30.158 14.2794 30.4393 14.5607C30.7206 14.842 31.1022 15 31.5 15H39L37.8683 7.0755C37.7661 6.36063 37.4095 5.70661 36.8639 5.2335C36.3183 4.76039 35.6204 4.49996 34.8982 4.5H30Z"
          fill="#D4E3F3"
        />
        <path
          d="M3 0H24C24.7956 0 25.5587 0.316071 26.1213 0.87868C26.6839 1.44129 27 2.20435 27 3V27H3C2.20435 27 1.44129 26.6839 0.87868 26.1213C0.31607 25.5587 0 24.7956 0 24V3C0 2.20435 0.31607 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0Z"
          fill="#A1C1E6"
        />
        <path
          d="M9 31.5C11.4853 31.5 13.5 29.4853 13.5 27C13.5 24.5147 11.4853 22.5 9 22.5C6.51472 22.5 4.5 24.5147 4.5 27C4.5 29.4853 6.51472 31.5 9 31.5Z"
          fill="#0E4686"
        />
        <path
          d="M9 29.25C10.2426 29.25 11.25 28.2426 11.25 27C11.25 25.7574 10.2426 24.75 9 24.75C7.75736 24.75 6.75 25.7574 6.75 27C6.75 28.2426 7.75736 29.25 9 29.25Z"
          fill="#D4E3F3"
        />
        <path
          d="M34.5 31.5C36.9853 31.5 39 29.4853 39 27C39 24.5147 36.9853 22.5 34.5 22.5C32.0147 22.5 30 24.5147 30 27C30 29.4853 32.0147 31.5 34.5 31.5Z"
          fill="#0E4686"
        />
        <path
          d="M34.5 29.25C35.7426 29.25 36.75 28.2426 36.75 27C36.75 25.7574 35.7426 24.75 34.5 24.75C33.2574 24.75 32.25 25.7574 32.25 27C32.25 28.2426 33.2574 29.25 34.5 29.25Z"
          fill="#D4E3F3"
        />
        <path d="M27.0156 18.75H0.015625V20.25H27.0156V18.75Z" fill="#4383CC" />
      </svg>
    </IconContainer>
  )
}
